<template>
  <b-container>
    <div class="b-main-content">

      <gmap-map
        :center="{ lat: 54.676655, lng: -1.209374}"
        :zoom="7"
        style="width:100%;  height: 600px;"
      >
        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen=false">
          {{ infoContent }}<br><router-link :to="infoLink">{{ infoThing }}</router-link>
        </gmap-info-window>

        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :icon="m.icon"
          :clickable="true"
          @click="toggleInfoWindow(m,index)"
        />
      </gmap-map>
    </div>
  </b-container> 
</template>

<script>
import { API } from 'aws-amplify'
import { mapState } from 'vuex'

export default {
  name: "GoogleMap",
  created: function () {
    //Fetch the data when the view is created and the data is already being observed
    this.updateTable()
  },
  watch: {
    '$route': 'updateTable'
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    })
  },
  data: function () {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      // center: { lat: 45.508, lng: -73.587 },
      center: [],
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      infoThing: 'none',
      infoLink: '/machine',
      currentMidx: null,
      infoOptions: { pixelOffset: { width: 0, height: -35} },
      markers: [
        {
          position: { lat: 54.607594, lng: -1.278823},
          infoText: 'Billingham, Loading Bay',
          thingName: "B01005",
          link: '/machine/B01005',
          map: this.map,
          title: 'Billingham, Loading Bay'
        }
      ],
      places: [],
      currentPlace: null,

      items: [
        {
          "Description": "Billingham, Loading Bay",
          "ThingName": "B01000",
          "email": "iguffick@4celectronics.co.uk",
          "Type": "B4 Baler",
          "Location": "54.607594, -1.278823",
          "Time": "2018-11-03 17:12:00.123",
          "OwnerID": "ian"
        }
      ]
    }
  },

  mounted() {
    this.geolocate()
  },

  methods: {
    updateTable: function() {


      this.items.splice(1)
      this.$set(this.items, 0, { "ThingName": "Loading...", "Link": "/machine", "Time": Date.now()})
      this.markers.splice(1)
      this.$set(this.markers, 0, { "position": { lat: 54.676655, lng: -1.209374}, "infoText": "Loading...", "title": "Loading..."})
      API.get('gbkpulseapi', '/listmachine', []).then(response => {
        // Add your code here
        console.log("api response =", response)
        var body = JSON.parse(response.body)
        console.log("body =", body)
        console.log("body[0] =", body[0])

	var currentdate = new Date()
	var deltatime = 8 * 60 * 60 * 1000;    //8 hours (in ms)

        for (var i = 0; i < body.length; i++) {
          var newitem = []
          newitem.ThingName = body[i].machineID
          newitem.Link = '/machine/' + body[i].machineID
          newitem.Description = body[i].description
          newitem.Type = body[i].type
          newitem.Location = body[i].position
          newitem.Time = body[i].time
          newitem.Bales = body[i].bales

          this.$set(this.items, i, newitem)


          var newmarker = []
          newmarker.position = { "lat": Number(body[i].position.split(',')[0]), "lng": Number(body[i].position.split(',')[1])}
          newmarker.infoText = body[i].description
          newmarker.thingName = body[i].machineID
          newmarker.link = '/machine/' + body[i].machineID
          newmarker.map = this.map
          newmarker.title = body[i].description
          newmarker.bales = body[i].bales

          var bodydate = new Date(body[i].time)
          if(bodydate.getTime() > (currentdate.getTime() - deltatime)) {
            newmarker.icon = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
          }
          else {
            newmarker.icon = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
          }

          this.$set(this.markers, i, newmarker)


          console.log("i = ", i)
          console.log("machineID =",body[i].machineID)
          console.log("marker = ", newmarker)
        }
      }).catch(error => {
        console.log(error.response)
      })


    },

    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.infoText
      this.infoThing = marker.thingName
      this.infoLink = marker.link
      
      //check if its the same marker that was selected, if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen
      }
      //if different marker, set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    },

    // receives a place object via the autocomplete component
    setPlace(place) {
      this.currentPlace = place
    },

    addMarker() {
      if (this.currentPlace) {
        //check bounds.extend and map.fitBounds
        
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        }
        this.markers.push({ position: marker })
        this.places.push(this.currentPlace)
        this.center = marker
        this.currentPlace = null
      }
    },

    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      })
    }
  }
}
</script>
